import { rtkApi, GET_TEACHER_COURSES } from '@/shared/api';
import { SuccessApiResponse } from '@/shared/types/common';
import {
  ITeacherCoursesRequest,
  ITeacherCoursesResponse,
} from './types';

const teacherCoursesApi = rtkApi.injectEndpoints({
  endpoints: (build) => ({
    getTeacherCourses: build.query<ITeacherCoursesResponse, ITeacherCoursesRequest | void>({
      query: (params) => {
        if (!params) {
          return '/teacher/courses';
        }
        return {
          url: '/teacher/courses',
          params,
        };
      },
      transformResponse: (response: SuccessApiResponse<ITeacherCoursesResponse>) => response.data,
      providesTags: [GET_TEACHER_COURSES],
    }),
  }),
});

export const {
  useGetTeacherCoursesQuery,
} = teacherCoursesApi;
